<template>
    <div class="picture-item-wrapper">
        <CoverPanel
            v-if="!isEditing"
            :no-cover-icon="noCoverIcon"
            :image-url="data.cardImage"
            :operate-icons="operateIcons"
            :view-icon="viewIcon"
            @viewClick="viewHandler"
            @operatorSelect="operatorSelect"
        />
        <AddRefCoverPanel
            v-if="isEditing"
            class="item-cover"
            :needClip="needClip"
            :alwayShowCancel="isEditing && this.data.cardImage"
            @change="coverChange"
            @cancel="coverCancel"
        />
        <LinkButton :data="data" @linkChange="linkChangeHandle" />
    </div>
</template>

<script>
import LinkButton from "@/views/zhiji/components/questionEdit/answers/widgets/LinkButton";
import AddRefCoverPanel from "@/views/zhiji/components/coverPanel/AddRefCoverPanel.vue";
import CoverPanel from "@/views/zhiji/components/coverPanel/CoverPanel";

export default {
    name: "Picture",
    components: {
        LinkButton,
        AddRefCoverPanel,
        CoverPanel
    },
    props: ["data"],
    data() {
        return {
            isEditing: !this.data.cardImage,
            isEditCover: false,
            needClip: false,
            noCoverIcon: {
                position: "-145px -50px",
                label: this.$t("zhiji.materialLibrary.addPicture")
            },
            operateIcons: [
                {
                    type: "updateImage",
                    position: "-38px -77px",
                    name: this.$t("zhiji.materialLibrary.replacePic")
                },
                {
                    type: "updateCover",
                    position: "-38px -77px",
                    name: this.$t("zhiji.answer.replaceCover")
                }
            ],
            viewIcon: {
                position: "-110px -85px"
            }
        };
    },
    computed: {
        hotPointData() {
            return {
                redState: this.data.redState,
                hotItem: this.data.hotItem,
                endTime: this.data.redHotEndTime
            };
        }
    },
    methods: {
        coverChange({ value }) {
            if (value) {
                this.isEditCover
                    ? this.commitUpdate({
                          cardImage: value
                      })
                    : this.commitUpdate({
                          image: value,
                          cardImage: value
                      });
            }
            this.isEditCover = false;
            this.isEditing = false;
            this.needClip = false;
        },
        coverCancel() {
            this.isEditCover = false;
            this.isEditing = false;
            this.needClip = false;
        },
        viewHandler() {
            this.$store.commit("zhiji/showModal", {
                type: "ImageViewModal",
                data: {
                    url: this.data.image
                }
            });
        },
        redSwitch(redState) {
            this.commitUpdate({
                redState
            });
        },
        hotSwitch(hotItem) {
            this.commitUpdate({
                hotItem
            });
        },
        hotDateChange(dateStr) {
            this.commitUpdate({
                redHotEndTime: dateStr
            });
        },
        commitUpdate(updateData) {
            updateData.uId = this.data.uId;
            updateData.updateState = "add";
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContent",
                widget: updateData
            });
        },
        linkChangeHandle(data) {
            this.commitUpdate(data);
        },
        operatorSelect(type) {
            if (type === "updateImage") {
                this.isEditCover = false;
            } else if (type === "updateCover") {
                this.isEditCover = true;
                this.needClip = true;
            }
            this.isEditing = true;
        }
    }
};
</script>

<style scoped lang="less">
.picture-item-wrapper {
    position: relative;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    font-size: 12px;
    flex-shrink: 0;
    box-sizing: border-box;
    width: 202px;

    .item-cover {
        width: 200px;
        height: 150px;
        border: none;
    }
}
</style>
